import type { ScaledSize } from 'react-native';

const STABLE_DIMENSIONS: ScaledSize = {
  width: typeof window !== 'undefined' ? window.innerWidth : 1280,
  height: typeof window !== 'undefined' ? window.innerHeight : 800,
  scale: 1,
  fontScale: 1,
};

/** Auth/login web screens use CSS media queries — no resize subscriptions. */
export const useStableWindowDimensions = (): ScaledSize => STABLE_DIMENSIONS;

export default useStableWindowDimensions;
